var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes},[_c('router-link',{staticClass:"back-button typeface-nav",attrs:{"to":_vm.homePath}},[_c('Icon',{attrs:{"icon":"home-alt"}}),_vm._v(" Back to menu")],1),(_vm.station.name)?_c('div',{staticClass:"station-name"},[_vm._v(" "+_vm._s(_vm.station.name)+" Station ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }